import AddToCartBase from "./add_to_cart_base";

export default class AddToCartOnce extends AddToCartBase {
  initialize() {
    this.url = this.element.dataset.cartUrl;
    this.plusButton.addEventListener("click", () => {
      this.postUpdatedQuantity();
    });
  }
}
